import React from "react";
import PropTypes from "prop-types";
import { Row, Label, Input } from "reactstrap";

const TextSection = ({
  showError,
  title,
  value,
  onChange,
  canEdit,
  isMultiline,
  maxLength,
  required
}) => {
  const isInvalid = showError && ((required && !value) || (required && value.length > maxLength));
  const invalidCss = isInvalid ? "is-invalid form-control" : "form-control";
  return (
    <div className="col-12">
      <Row className="mb-3">
        <div className="col-md-12">
          <Label className={!isInvalid || "text-danger"}>
            {title}
            {required && <span className="text-danger"> * </span>}
          </Label>
          {!isMultiline ? (
            <Input
              className={invalidCss}
              type="text"
              value={value}
              onChange={event => {
                const textValue = event.target.value;
                if (textValue.length <= maxLength) {
                  onChange(textValue);
                }
              }}
              disabled={canEdit}
            />
          ) : (
            <textarea
              className={invalidCss}
              value={value}
              onChange={event => onChange(event.target.value)}
              disabled={canEdit}
            />
          )}
          {isInvalid && (
            <div className="invalid-feedback">{`Campo obligatorio con longitud igual o inferior a ${maxLength}`}</div>
          )}
        </div>
      </Row>
    </div>
  );
};

TextSection.propTypes = {
  showError: PropTypes.bool,
  title: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func,
  canEdit: PropTypes.bool,
  isMultiline: PropTypes.bool,
  maxLength: PropTypes.number,
  required: PropTypes.bool
};
TextSection.defaultProps = {
  showError: false,
  title: "",
  value: "",
  onChange: () => {},
  canEdit: true,
  isMultiline: false,
  maxLength: 10,
  required: true
};
export default TextSection;
